<div>
  <table mat-table multiTemplateDataRows class="w-full" [dataSource]="scoreDataSource">
    <ng-container matColumnDef="sections">
      <th mat-header-cell *matHeaderCellDef class="table-header">Sections</th>
      <td mat-cell *matCellDef="let score" class="cursor-pointer">
        {{ score.section }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actual">
      <th mat-header-cell *matHeaderCellDef class="table-header">
        <div class="text-left">Actual</div>
      </th>
      <td mat-cell *matCellDef="let score" class="cursor-pointer">
        {{ score.actual }}
      </td>
    </ng-container>
    <ng-container matColumnDef="possible">
      <th mat-header-cell *matHeaderCellDef class="table-header" colspan="2">Possible</th>
      <td mat-cell *matCellDef="let score" class="cursor-pointer">
        {{ score.possible }}
      </td>
    </ng-container>
    <ng-container matColumnDef="percent">
      <!-- td instead of th because of WCAG standards -->
      <td mat-header-cell *matHeaderCellDef class="table-header"></td>
      <td mat-cell *matCellDef="let score">
        {{ score.percent ?? '' }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="scoreColumnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: scoreColumnsToDisplay" [ngClass]="row?.section !== 'Total' ? 'hover:bg-gray-100' : 'total-row'"></tr>
  </table>
  @if (displayMinimumToPass) {
    <div class="minimum-info">{{ isPassingString }}</div>
  }

  <!-- <div class="fixed-score-card">
  <div *ngIf="isPassing" class="pass-score">
    <span class="score-text">
      Score
    </span>
    <mat-icon class="pass-icon">done</mat-icon>
    <span class="pass-fail-text">PASS</span>
  </div>
</div>

<div class="fixed-score-card">
  <div *ngIf="!isPassing" class="fail-score icon-container">
    <span class="score-text">
      Score
    </span>
    <mat-icon class="fail-icon">clear</mat-icon>
    <span class="pass-fail-text">FAIL</span>
  </div>
</div> -->
</div>
